<template>
  <div>
    <section id="sub_visual" class="pic06">
      <p>이트너스 페이롤 소개 </p>
      <span>About etnerspayroll Service</span> </section>
    <main id="page_sub">
      <section id="page_contents" class="sub_con06 clear">
        <h6>급여전문성은 Plus +<br/>
          편의성 ,생산성은 Up↑</h6>
        <span class="ctext1">이트너스 페이롤은 급여와 관련된 제반 관리 및 <br>
      인사, 노무 컨설팅을 통한
      전문 급여 토탈 서비스를 제공합니다. </span>
        <p class="ctext2 mr0 t-ar pt50"><span class="cbig">Why</span><span class="pl0">etners Payroll?</span></p>
        <!--- 특징 --->
        <div class="clearfix">
          <ul class="platform">
            <li class="thr">
              <p><img src="../../assets/images/c_im_21.png" width="104" height="104" alt=""/></p>
              <h6>급여 관련된 인사,노무 컨설팅을 통한 서비스 제공</h6>
              <p>단순한 급여 뿐만아니라 4대보험,원천세,퇴직금,연말정산을 포함한 인사노무 컨설팅으로 고객의 기업경쟁력 집중에 도움을 드립니다.</p>
            <li class="thr">
              <p><img src="../../assets/images/c_im_22.png" width="104" height="104" alt=""/></p>
              <h6>법 개정 사항에 대한 신속 정확한 조치 </h6>
              <p>세법 변경 및 연말정산 관련 내용변경등에 대하여 신속하고 정확하게 조치 반영을 보장합니다. 또한 개정사항 및 이슈사항들을 고객에게 정보제공합니다. </p>
            </li>
            <li class="thr">
              <p><img src="../../assets/images/c_im_23.png" width="104" height="104" alt=""/></p>
              <h6>완벽한 시스템 및 물리적 보안관리 </h6>
              <p>급여정보에 대한 제한적 접근 권한을 통해 통제 및 관리를 하고 있으며 24시간 전문업체 보안관제(IDC)로 체계적 보안정책 및 개인정보보호 시스템을 운영하고 있스니다. (ISO 인증) </p>
            </li>
          </ul>
          <!---페이롤서비스 --->
          <h4>About Payroll Service</h4>
          <ul class="platform">
            <li class="six">
              <p><img src="../../assets/images/se_01.png" alt=""/></p>
              <h6>급여 </h6>
            </li>
            <li class="six">
              <p><img src="../../assets/images/se_02.png" alt=""/></p>
              <h6>4대보험 </h6>
            </li>
            <li class="six">
              <p><img src="../../assets/images/se_03.png" alt=""/></p>
              <h6>원천세 </h6>
            </li>
            <li class="six">
              <p><img src="../../assets/images/se_04.png" alt=""/></p>
              <h6>퇴직금 </h6>
            </li>
            <li class="six">
              <p><img src="../../assets/images/se_05.png" alt=""/></p>
              <h6>연말정산 </h6>
            </li>
            <li class="six">
              <p><img src="../../assets/images/se_06.png" alt=""/></p>
              <h6>자문서비스 </h6>
            </li>
          </ul>
          <!---//페이롤서비스 --->
        </div>
        <!--- //특징 --->
        <go-solution :solutionUrl="url" :solCd="solCd" :solGrup="10" :solNm="solNm"></go-solution>
      </section>
    </main>
  </div>
</template>

<script>
  import GoSolution from "../../components/goSolution";
  export default {
    components: {GoSolution},
    data() {
      return{
        url:'http://www.etnerspayroll.com',
        solNm :'이트너스페이롤',
        solCd : '2007'

      }
    }
  }

</script>
